import { Link } from "react-router-dom";
import MainContent7 from "../MainContent7";
import AsideContent2 from "../AsideContent2";
import GoToTop from "../GoToTop";
// import ResourcesList from "../assets/resources/ResourcesList";
// import ResourcesListAside from "../assets/resources/ResourcesListAside";
// import TranscriptsList from "../assets/transcripts/TranscriptsList";
import TranscriptsList from "../assets/TranscriptsList";
// import TranscriptsListAside from "../assets/transcripts/TranscriptsListAside";




const TranscriptsPage = () => {
    return (
        <div className="content">
            <main>
                <MainContent7 resource={TranscriptsList}/>
                <h2 className="back"><Link to="/Transcripts" title="Back to Top" className="backLink link">- BACK To TOP -</Link></h2>
            </main>
            <aside>
                <AsideContent2 resource={TranscriptsList}/>
            </aside>
            <GoToTop />
  	    </div>
    );
};
export default TranscriptsPage;